export type VarianceTone = 'over' | 'under' | 'even' | 'none';

/** Positive variance = logged more than estimated (over). Null = nothing logged yet. */
export function varianceTone(minutes: number | null): VarianceTone {
  if (minutes === null) return 'none';
  if (minutes > 0) return 'over';
  if (minutes < 0) return 'under';
  return 'even';
}

export function variancePct(estimate: number, logged: number): number | null {
  if (estimate <= 0 || logged <= 0) return null;
  return Math.round(((logged - estimate) / estimate) * 100);
}
